"use strict";
/**
 *
 * The horizontal spinner js logic.
 * The horizontal spinner is the number input with the +/- buttons at either of
 * it's sides.
 *
 */

const $ = require("jquery");
const {
  setIncompleteTrap
} = require("./../booking-incomplete-form/booking-incomplete-form");

/**
 *
 * Resets the buttons' disabled state to *not* disabled.
 *
 * @param {object} spinner The reference to the spinner html object.
 * @param {object} leftButton The reference to the left button html object.
 * @param {object} rightButton The reference to the right button html object.
 */
function resetButtonState(spinner, leftButton, rightButton) {
  $(spinner).removeClass("horizontal-spinner--left-button-disabled");
  $(spinner).removeClass("horizontal-spinner--right-button-disabled");
  $(leftButton).attr("disabled", false);
  $(rightButton).attr("disabled", false);
}

/**
 *
 * Handles the buttons' disabled status.
 *
 * @param {number} newValue The next value of the spinner
 * @param {number} minimum The minimum number that the spinner can accept.
 * @param {number} maximum The maximum number that the spinner can accept.
 * @param {object} spinner The reference to the spinner html object.
 * @param {object} leftButton The reference to the left button html object.
 * @param {object} rightButton The reference to the right button html object.
 */
function hanldeButtons(
  newValue,
  minimum,
  maximum,
  spinner,
  leftButton,
  rightButton
) {
  if (newValue <= minimum) {
    $(spinner).addClass("horizontal-spinner--left-button-disabled");
    $(leftButton).attr("disabled", true);
  } else {
    $(spinner).removeClass("horizontal-spinner--left-button-disabled");
    $(leftButton).attr("disabled", false);
    //$(spinner).children().$('.upsales-form__invalid-text').html("");
    $(spinner)
      .find(".upsales-form__invalid-text")
      .css({ display: "none" });
    $(spinner)
      .find(".form-control.is-invalid")
      .css({
        "border-color": "#ced4da",
        "background-image": "none",
        color: "black"
      });
    //$(spinner).find(".is-invalid").css({"text-color":"black"});
  }

  //$(spinner).children().removeClass("upsales-form__invalid-text");
  //$(spinner).find('upsales-form__invalid-text').css("");

  //$(".upsales-form__invalid-text").removeClass

  if (newValue >= maximum) {
    $(spinner).addClass("horizontal-spinner--right-button-disabled");
    $(rightButton).attr("disabled", true);
  } else {
    $(spinner).removeClass("horizontal-spinner--right-button-disabled");
    $(rightButton).attr("disabled", false);
  }
}

/**
 *
 * Handles the button click.
 *
 * @param {object} spinner The reference to the spinner html object.
 * @param {string} sign The positive or negative sign.
 * @param {object} leftButton The reference to the left button html object.
 * @param {object} rightButton The reference to the right button html object.
 * @param {object} numberInput The reference to the number input html object.
 * @param {number} minimum The minimum number that the spinner can accept.
 * @param {number} maximum The maximum number that the spinner can accept.
 * @param {string} step The stringified version of the number.
 * @param {string} decimalPoint The sign of the decimal point to be used.
 */
function onButtonClick(
  spinner,
  sign,
  leftButton,
  rightButton,
  numberInput,
  minimum,
  maximum,
  step,
  decimalPoint
) {
  setIncompleteTrap();

  let value = $(numberInput)
    .val()
    .replace(decimalPoint, ".");

  if (value.indexOf(".") >= 0) {
    value = value.substring(0, value.indexOf(".") + 3);
  }

  const hasValue = value.length > 0;

  const signedStep = sign === "+" ? step : step * -1;

  const valueError = isNaN(Number(value));

  const newValue =
    !hasValue || valueError ? minimum : Number(value) + signedStep;

  // handle the arithmetic error.
  const roundedValue = (Math.round(newValue * 100) / 100).toString();

  hanldeButtons(newValue, minimum, maximum, spinner, leftButton, rightButton);

  const transformedValue = roundedValue.toString().replace(".", decimalPoint);
  $(numberInput).val(transformedValue);
}

/**
 *
 * Initializes the horizontal spinner and add callbacks at the buttons.
 *
 */
function onLoad() {
  $(".js-horizontal-spinner").each(function(_, spinner) {
    const leftButton = $(spinner).find(".horizontal-spinner__button--left");
    const rightButton = $(spinner).find(".horizontal-spinner__button--right");
    const numberInput = $(spinner).find(".horizontal-spinner__input");
    const minimum = Number($(numberInput).attr("min"));
    const maximum = Number($(numberInput).attr("max"));
    const step = Number($(numberInput).attr("data-step"));
    const decimalPoint = $(numberInput).attr("data-decimalpoint");

    let value = $(numberInput)
      .val()
      .replace(".", decimalPoint);
    $(numberInput).val(value);

    $(leftButton).on("click", function() {
      onButtonClick(
        spinner,
        "-",
        leftButton,
        rightButton,
        numberInput,
        minimum,
        maximum,
        step,
        decimalPoint
      );
    });

    $(rightButton).on("click", function() {
      onButtonClick(
        spinner,
        "+",
        leftButton,
        rightButton,
        numberInput,
        minimum,
        maximum,
        step,
        decimalPoint
      );
    });

    $(numberInput).on("input", function(e) {
      const value = Number($(e.tartget).val());
      if (value.length === 0 || isNaN(value)) {
        resetButtonState(spinner, leftButton, rightButton);
      }
    });
    $(numberInput).on("input", function() {
      const mynuminp = $(this).val();
      if (mynuminp > 198) {
        $(spinner)
          .find(".upsales-form__invalid-text")
          .css({ display: "none" });
        $(spinner)
          .find(".form-control.is-invalid")
          .css({
            "border-color": "#ced4da",
            "background-image": "none",
            color: "black"
          });
      }
      if ($(spinner).attr("data-default-value") == 20) {
        if (mynuminp > 19) {
          $(spinner)
            .find(".upsales-form__invalid-text")
            .css({ display: "none" });
          $(spinner)
            .find(".form-control.is-invalid")
            .css({
              "border-color": "#ced4da",
              "background-image": "none",
              color: "black"
            });
        }
      }
    });
  });
}
module.exports = {
  onLoad: onLoad
};



// WEBPACK FOOTER //
// ./resources/js/libraries/booking-horizontal-spinner/booking-horizontal-spinner.js